import { getUrlParams, getSignedParams, getPhpNow, getUdid, getUUids } from '@/utils';
import { getConfig, init, login, pay, role, online, openRebate, pushPopImg, getYanfaRedpacket } from '@/api/mixServer';
import { mixServerConfig } from '@/config';
import server, { sendMsg } from './index';
import store from '@/store';
import { Dialog } from 'vant';

const mixServer = {
  appid: getUrlParams('appid'),
  // 配置接口返回结果
  configData: {},
  // 初始化返回结果
  initData: {
    // 在线时长上报间隔
    alive: 20
  },
  // 是否开启防沉迷
  isAntiAddiction: 1,
  // 玩家实名状态
  force_cert_status: '',
  // 过期时间
  expire_time: '',
  // 当前时间戳
  currentTime: '',
  // 强制玩家下线时间
  expireTime: '',
  // 乐牛应用ID
  ln_appid: '',
  // 融合SDK的秘钥
  app_key: '',
  // 游戏链接
  game_link: '',
  // 融合access_token
  access_token: '',
  record_number: '',
  record_number_url: '',
  getConfig() {
    const params = {
      appid: this.appid,
      notch_height: getUrlParams('notch_height') || '0',
      bottom_height: getUrlParams('bottom_height') || '0',
      uuid: getUUids() || '',
      idfa: getUrlParams('idfa') || '',
      time: getPhpNow()
    };
    const signedParams = getSignedParams(mixServerConfig.app_key, params);
    return getConfig(signedParams).then(res => {
      const { data = {} } = res;
      this.configData = data;
      this.ln_appid = data.ln_appid || '';
      const app_key = data.app_key || '';
      this.app_key = app_key;
      mixServerConfig.api_app_key = app_key;
      this.game_link = data.game_link || '';
      document.title = data.game_title || '名酱三国';
      return res;
    });
  },
  init() {
    // 获取浏览器唯一标识
    return new Promise((resolve, reject) => {
      getUdid()
        .then(udid => {
          const params = {
            appid: this.appid,
            time: getPhpNow(),
            ver: server.ver,
            udid: udid,
            uuid: udid,
            ...server.shareParams
          };
          // console.log(this.app_key)
          const signedParams = getSignedParams(this.app_key, params);
          init(signedParams)
            .then(res => {
              const { data = {} } = res;
              this.initData = data;
              const access_token = data.access_token || '';
              this.access_token = access_token;
              mixServerConfig.access_token = access_token;
              this.isAntiAddiction = data.is_anti_addiction; // 是否开启防沉迷
              this.record_number = data.record_number;
              this.record_number_url = data.record_number_url;
              // 存储过审状态用于未过审的情况下登录界面增加删除账号功能
              localStorage.setItem('ln_is_vertify', data.is_vertify);
              // 2021.12.9个人信息法存储游戏声明更新版本
              if (localStorage.getItem('ln_user_ver') && localStorage.getItem('ln_user_ver') != data.protocal_version) {
                // 上一次有同意过才提示更新版本
                if (localStorage.getItem('ln_agree') == 2) {
                  store.commit('SHOW', {
                    name: 'GameState',
                    params: { isVer: true, verUrl: data.protocal_update, status: 1 }
                  });
                  localStorage.setItem('ln_user_ver', data.protocal_version);
                  store.commit('SET_GAMESTATEVER', data.protocal_update);
                  return;
                } else {
                  store.commit('SHOW', {
                    name: 'GameState',
                    params: { isVer: false }
                  });
                }
              } else {
                // 如果弹了更新后的版本，再点拒绝，下次进入还会继续弹更新后的版本
                if (localStorage.getItem('ln_status') == 1) {
                  console.log(data.protocal_update);
                  store.commit('SHOW', {
                    name: 'GameState',
                    params: { isVer: true, verUrl: data.protocal_update, status: 1 }
                  });
                  return;
                }
                localStorage.setItem('ln_user_ver', data.protocal_version);
              }
              // store.commit('SET_ISHOVER', true)
              if (this.game_link.indexOf('huanyuantech.com') > -1 || this.game_link.indexOf('youyantech') > -1) {
                store.commit('SET_ISHOVER', false);
              } else {
                store.commit('SET_ISHOVER', true);
              }
              // 传给oc hackjs解决ipad云闪付
              try {
                let hackjs = [data.hackjs];
                window.webkit.messageHandlers['hackExt'].postMessage({ params: hackjs });
              } catch (error) {
                console.log(error);
              }
              resolve(res);
            })
            .catch(error => {
              console.error('融合SDK初始化失败:', error);
              reject(error);
            });
        })
        .catch(error => {
          console.error('获取浏览器唯一标识错误:', error);
          reject(error);
        });
    });
  },
  login(params) {
    let onlieParams = { roleid: '', server_id: '', ver: getUrlParams('ver') };
    // 是否开启红包功能参数（227测试）
    const rebateAct = {
      ln_uid: '5298824078',
      server_no: '124564',
      role_id: '12054',
      level: 100,
      role_name: '测试红包',
      server_name: '测试区服'
    };
    // 切换账号重新登录初始化红包弹窗状态
    store.commit('SET_RABTOPEN', false);
    // this.getRebateAct(rebateAct);
    return new Promise((resolve, reject) => {
      login(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          if (store.state.isCertName) {
            sendMsg('LOGIN_SUCCESS', {
              account: data.account,
              uid: data.union_uid,
              token: data.login_token,
              ip_info: data.ip_info,
              cp_storage: localStorage.getItem('cp_storage') || '',
              client_type: getUrlParams('client_type') || '',
              record_number: this.record_number,
              record_number_url: this.record_number_url,
              fu_uid: data.fu_uid,
              appid: getUrlParams('appid')
            });
          }
          // payCallBack({order_id: '210909140734568621467', receipt: '1323wsdeqadad'});
          // 25.03.27天剑转端应用增加版号图片覆盖
          const copyRightAppid = [
            '68976',
            '68980',
            '68984',
            '68952',
            '68956',
            '68960',
            '69044',
            '69048',
            '69052',
            '69166',
            '69170',
            '69174',
            '69376',
            '69380',
            '69384',
            '70584',
            '70588',
            '70592',
            '71288', 
            '71292', 
            '71296',
            '71812', 
            '71816', 
            '71820'
          ];
          if (copyRightAppid.includes(this.appid)) {
            store.commit('SET_COPYRIGHT', true);
          }
          // 拍脸图配置
          this.getPushPopConfig();

          resolve(data);
        } else {
          Dialog({ message: msg });
        }
        // this.onlineCommit(onlieParams); // 融合登录进行上报时长
      });
    });
  },
  //  当游戏id为'88'时在融合登录进行在线时长上报(包括首次和后续)
  onlineCommit(onlineParams) {
    // if (getUrlParams('game_id') != 88) return; // 当游戏id为88时不执行上报时长逻辑
    // 首次上报
    this.online({ ...onlineParams, seconds: 0, type: 1 }).then(data => {
      // 弹出实名登记
      const toCert = data => {
        store.commit('SHOW', {
          name: 'Certification',
          // 在线时长弹出，一定是强制
          params: { ...data, isForceCert: true, is_close: false }
        });
      };
      // 需要弹出实名认证
      // if (this.isAntiAddiction == 1) {
      //   if (data.is_allow_online == 0) {
      //     if (store.state.user.cert_type != 1) {
      //       // 如果登录时没有弹出实名认证，则在这里弹出
      //       toCert(data);
      //     }
      //     // 如果不允许在线，强制重启游戏,不后续上报
      //     this.reloadGameFrame();
      //     return;
      //   }
      // }
      this.expire_time = data.expire_time;
      if (this.isAntiAddiction == 1) {
        if (data.is_allow_online == 0) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 1) {
            // 强制退出游戏的弹窗不可关闭
            Dialog.alert({
              title: '',
              message: data.cert_msg,
              theme: 'round-button'
            }).then(() => {
              this.reloadGameFrame(); // 退出游戏
            });
            clearInterval(this.timer);
            return;
          } else if (data.type == 2) {
            // 实名认证弹窗不可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: false }
            });
            clearInterval(this.timer);
            return;
          }
          // 如果不允许在线，强制重启游戏,不后续上报
          // toCert(data);
          // this.reloadGameFrame();
          // clearInterval(this.timer);
        } else if (data.is_allow_online == 1) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 2) {
            // 弹窗实名认证弹窗，可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: true }
            });
          }
        }
      }
      // 后续上报
      const alive = mixServer.initData.alive;
      if (alive) {
        this.timer = setInterval(() => {
          this.online({ ...onlineParams, seconds: alive, type: 2 }).then(data => {
            console.log(data);
            if (this.isAntiAddiction == 1) {
              if (data.is_allow_online == 0) {
                if (data.type == 0) {
                  store.commit('CLOSE');
                } else if (data.type == 1) {
                  // 强制退出游戏的弹窗不可关闭
                  Dialog.alert({
                    title: '',
                    message: data.cert_msg,
                    theme: 'round-button'
                  }).then(() => {
                    this.reloadGameFrame(); // 退出游戏
                  });
                  clearInterval(this.timer);
                } else if (data.type == 2) {
                  // 实名认证弹窗不可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: false }
                  });
                  clearInterval(this.timer);
                }
                // 如果不允许在线，强制重启游戏,不后续上报
                // toCert(data);
                // this.reloadGameFrame();
                // clearInterval(this.timer);
              } else if (data.is_allow_online == 1) {
                if (data.type == 0) {
                  store.commit('CLOSE');
                } else if (data.type == 2) {
                  // 弹窗实名认证弹窗，可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: true }
                  });
                }
              }
            }
          });
        }, +mixServer.initData.alive * 1000);
      }
    });
  },
  pay(params) {
    return new Promise((resolve, reject) => {
      pay(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 支付成功
          sendMsg('PAY_SUCCESS', { message: msg });
          resolve(data);
        } else if (ret == 81023) {
          // 实名验证
          store.commit('SHOW', {
            name: 'Certification',
            params: { isPay: true, payMsg: msg, payParams: params, is_close: true, expire_time: server.expire_time }
          });
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  role(params) {
    return new Promise((resolve, reject) => {
      role(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 角色上报成功,不需反馈给游戏端
          // sendMsg('ROLE_REPORT_SUCCESS');
          resolve(data);
        } else {
          console.error('角色上报失败:' + msg);
        }
      });
    });
  },
  online(params) {
    return new Promise((resolve, reject) => {
      online(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 在线时长上报成功,不需反馈给游戏端
          resolve(data);
        } else {
          console.error('在线时长上报失败:' + msg);
        }
      });
    });
  },
  getRebate(params) {
    return new Promise((resolve, reject) => {
      openRebate(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          console.error('获取红包开启失败:' + msg);
        }
      });
    });
  },
  getYfRebate(params) {
    return new Promise((resolve, reject) => {
      getYanfaRedpacket(params).then(({ ret, msg, data }) => {
        // if (ret == 0) {
          // resolve(data);
          resolve({ret, msg, data});
        // } else {
        //   console.error('获取红包开启失败:' + msg);
        // }
      });
    });
  },
  // 是否开启红包（227测试）
  getRebateAct(params) {
    this.getRebate(params).then(data => {
      if (data.open == 1) {
        store.commit('SET_OPEN', true);
        // let url = 'http://ucash.leniugame.com/ucashfront/#/?tk=2e98c536ba7d0f14f441c1f766fdd312b08628a914e118fd55a6f7c3b78041532ca7683ac8cf86120fbc02768e6a96d82438b2f4ba4421f24a91e23c81b43e0fa3f63602f26faddeb4b16a7bc8b1f0c003683cfc8e5841c1a064c454dbde49d4db9101634e5cbfb8f6bacf132af6a87adbfc153fd8ae8819f708316d8bc48af0cb4d20c134e4c4abd383a96844b5e374436189b0c07e47c06d689e9c797289dce4280305a4634a78e84235cf651c887fc75ec847c90b0bbedfde942952558ee366f0edb46e5071f32383428c3417e15f484d39ccef6f102a477fed2a24243dc1f32981927678f296eb11b5efe689621f4fcce971270395a0&access_token=5432abe67c0df8199e8203ed6cd3df80b6db64ecd679475f40dbcac1d5fcbbda27768540b9b33fa90c3e1219ef7c039473d49debde0e59b1417bc2246826b2f79bb8df385756b26896b72e45a523c05ba27c40312129f557d9a171418374dd977afed41954b845a5';
        store.commit('SET_REBATEURL', `${data.url}?tk=${data.tk}&access_token=${mixServerConfig.access_token}&sdk=h5`);
        // store.commit('SET_REBATEURL', url);
      } else {
        store.commit('SET_OPEN', false);
      }
    });
  },
  // 获取拍脸图弹窗配置
  getPushPopConfig(params) {
    pushPopImg(params).then(data => {
      console.log('拍脸图配置：', data);
      store.commit('SET_PUSHCONFIG', data.data);
    });
  }
};

export default mixServer;
